import axios, { AxiosInstance, AxiosRequestConfig } from "axios";

import { getAuthorizationHeader } from "./authentication/helpers";

const client: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

client.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    config.headers = { ...config.headers, ...getAuthorizationHeader() };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default client;
